import React, {useEffect } from 'react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';
import { dovalRank, dovalInterv } from './AuxVal.js';
import { doodeRank, doodeInterv } from './AuxOde.js';
import { doodvRank, doodvInterv } from './AuxOdv.js';
import { docartRank, docartInterv } from './AuxCart.js';
import { dopoRank, dopoInterv } from './AuxPomp.js';
import { dotmsRank, dotmsInterv } from './AuxTms.js';


function MapaExp(props) {
  
    const center = {lat: 41.18, lng: -8.6}; // Porto
    const zoom = 11;
    let opac = props.opac;
    let leftM = '0px';
    if (props.menuVisiv) leftM = '120px';
    const containerStyle = {
        position: 'fixed',
        width: '100%',
        height: '900px',
        marginLeft: leftM,
        opacity: opac
    };

    let nv;
    let shortv;
        
    useEffect(() => {
        
        const addShapes = () => {
            console.log(document.title);
            setTimeout(()=> {
                if (document.getElementById('branco')) document.getElementById('branco').style.display = 'none';
            }, 1000);
            let mapa = new window.google.maps.Map(document.getElementById('map'), {
                center: center, // Porto
                zoom: 11
            });
            document.getElementById('map').style.display = 'block';
            switch (props.comp + props.specs.crit) {
                case 'valRanking':
                    dovalRank (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'valIntervalo':
                    dovalInterv (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'odeRanking':
                    doodeRank (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'odeIntervalo':
                    doodeInterv (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'odvRanking':
                    doodvRank (props.ling, mapa, props.specs.res, props.specs.est, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'odvIntervalo':
                    doodvInterv (props.ling, mapa, props.specs.res, props.specs.est, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'cartRanking':
                    docartRank (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'cartIntervalo':
                    docartInterv (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1],props.specs.lims[2],props.specs.lims[3]);
                    break;
                case 'pompRanking':
                    nv = parseInt(props.specs.nv);    
                    shortv = props.varGlob.shortvar[nv];
                    dopoRank (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1], props.specs.lims[2], props.specs.lims[3] , props.varGlob.fvar[nv], shortv);
                    break;
                case 'pompIntervalo T':
                    nv = parseInt(props.specs.nv);    
                    shortv = props.varGlob.shortvar[nv];
                    shortv = shortv.replace("AB", " para Trindade");
                    shortv = shortv.replace("BA", " de Trindade");
                    dopoInterv (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1], props.specs.lims[2], props.specs.lims[3], props.varGlob.fvar[nv], props.varGlob.fvarT, parseInt(props.specs.nv), shortv);
                    break;
                case 'pompIntervalo AB':
                    nv = parseInt(props.specs.nv);    
                    shortv = props.varGlob.shortvar[nv];
                    dopoInterv (props.ling, mapa, props.specs.res, props.specs.lims[0], props.specs.lims[1], props.specs.lims[2], props.specs.lims[3], props.varGlob.fvar[nv], props.varGlob.fvarT, parseInt(props.specs.nv), shortv);
                    break;
                case 'tmsRanking':
                    nv = parseInt(props.specs.nv);    
                    shortv = props.varGlob.shortvartms[nv];
                    dotmsRank (props.ling, mapa, props.varGlob.coords, props.specs.res, props.specs.lims[0], props.specs.lims[1], props.specs.lims[2], props.specs.lims[3], nv, props.varGlob.stationAtms, props.varGlob.stationBtms, shortv);
                    break;
                case 'tmsIntervalo':
                    nv = parseInt(props.specs.nv);    
                    shortv = props.varGlob.shortvartms[nv];
                    dotmsInterv (props.ling, mapa, props.varGlob.coords, props.specs.res, props.specs.lims[0], props.specs.lims[1], props.specs.lims[2], props.specs.lims[3], nv, props.varGlob.stationAtms, props.varGlob.stationBtms, shortv);
                    break;
                default:
                    // loadMap(); 
            }
            let s = {...props.specs};
            props.setSpecs(s);
    
        };

        if (props.specs.res) { 
            addShapes(props.specs.mapa); 
        } else {
            if (document.getElementById('branco')) document.getElementById('branco').style.display = 'block';
            if (document.getElementById('map')) document.getElementById('map').style.display = 'none';
        }

    }, [props.specs.res, props.comp]);

    
    return (
        <div>
        <LoadScript googleMapsApiKey="AIzaSyAy9blTcp0rMZFyStb3AHdYsRPRpyVWRa4">
            <GoogleMap id="branco"
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoom}
            >
            </GoogleMap>
            <GoogleMap id="map"
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoom}
            >
            </GoogleMap>
        </LoadScript>
        </div>
    )
}

export default React.memo(MapaExp)